import { Route } from '@angular/router';

export const apiTokenSettingsRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import('./list/api-token-settings-list.component').then(
            (m) => m.ApiTokenSettingsListComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/api-token-settings-detail.component').then(
            (m) => m.ApiTokenSettingsDetailComponent
          ),
      },
      {
        path: 'detail/:tokenId',
        loadComponent: () =>
          import('./detail/api-token-settings-detail.component').then(
            (m) => m.ApiTokenSettingsDetailComponent
          ),
      },
      {
        path: 'edit/:tokenId',
        loadComponent: () =>
          import('./detail/api-token-settings-detail.component').then(
            (m) => m.ApiTokenSettingsDetailComponent
          ),
      },
    ],
  },
];
